import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { PasswordRecoveryService, SecretData, SelectedVerificationMethodInfo } from 'src/app/shared/services/password-recovery.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-token-confirmation-page',
  templateUrl: './token-confirmation-page.component.html',
  styleUrls: ['./token-confirmation-page.component.scss']
})
export class TokenConfirmationPageComponent implements OnInit {

  verificationMethodInfo: SelectedVerificationMethodInfo | null;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');

  constructor(
    private passwordRecoveryService: PasswordRecoveryService,
    private router: Router,
    private location: Location,
    public breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit(): void {
    this.verificationMethodInfo = this.passwordRecoveryService.getSelectedVerificationMethodInfo();
    this.passwordRecoveryService.clearSecretKey();

    if (!this.verificationMethodInfo) {
      this.router.navigate(['/']);
      return;
    }
  }

  handleConfirmToken(secretData: SecretData) {
    if (secretData) {
      this.passwordRecoveryService.setSecretKey(secretData);
      this.router.navigate(['/recuperar-senha/alterar'])
    }
  }

  handleGoBack() {
    this.location.back();
  }

}
